import React, { useState } from 'react';
import './BeforeAfter.css';

function BeforeAfter() {
  const [selectedHorse, setSelectedHorse] = useState(0);
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);

  const horses = [
    {
      name: "Romeo",
      location: "4 Jahre alt",
      beforeImage: "/img/romeo_vorher.jpg",
      afterImage: "/img/romeo_nachher.jpg",
      beforeText: "Romeo kam im Oktober 2024 zu mir, er hatte Würmer und war total abgemagert, er wollte sich nicht bewegen und war schwer krank.",
      afterText: "Romeo hat am ganzen Körper an Muskulatur zugenommen und ist auch in der Knochenmasse gewachsen. Im nächsten Monat (November) wird er endlich Reitpferd."
    },
    {
      name: "Dobby",
      location: "8 Jahre alt",
      beforeImage: "/img/dobby_1.jpg",
      afterImage: "/img/dobby_2.jpg",
      beforeText: "Dobby zeigte eine deutliche Schiefstellung und Überbauung. Seine Muskulatur war unausgewogen, besonders im Rückenbereich. Die Hinterhand war nicht korrekt gewinkelt und die Vorhand überlastet.",
      afterText: "Dobby hat in 5 Monaten seine gesamte Muskulatur und die Statik umgebaut. Er hat Muskulatur im Rücken aufgebaut, die Vorhand entlastet und vor allem die Hinterhand in einem korrekten Winkel hingestellt."
    },
    {
      name: "Otti",
      location: "4 Jahre alt",
      beforeImage: "/img/otti_2.jpg",
      afterImage: "/img/otti_1.jpg",
      beforeText: "Otti stand deutlich überbaut und zeigte Instabilität im Rückenbereich. Seine kompensatorische Muskulatur war stark verspannt, was seine natürliche Bewegung einschränkte. Die Vorhand war tief und schwer.",
      afterText: "Nach 6 Monaten intensiver Arbeit ist Otti ein neues Pferd. Er steht nicht mehr überbaut, hat Stabilität im Rücken aufgebaut und die Vorhand angehoben. Er hat in der kompensatorischen Muskulatur losgelassen und kann sich nun in seinem Körper so richtig wohl fühlen."
    },
    {
      name: "Luna",
      location: "10 Jahre alt",
      beforeImage: "/img/luna_1.jpg",
      afterImage: "/img/luna_2.jpg",
      beforeText: "Luna zeigte starke Verspannungen im gesamten Körper, besonders im Halsbereich. Sie arbeitete viel über den Hals, um die Vorhand anzuheben, was zu weiteren Verspannungen führte.",
      afterText: "Nach 6 Monaten ist Luna deutlich weniger angespannt. Sie kann die Vorhand anheben, ohne dafür über den Hals zu arbeiten."
    },
    {
      name: "Hermine",
      location: "14 Jahre alt",
      beforeImage: "/img/hermine_1.jpg",
      afterImage: "/img/hermine_2.jpg",
      beforeText: "Hermine hatte massive Blockaden und Verspannungen im gesamten Körper. Ihre Wirbel waren eingeengt, was zu einer verkürzten Körperhaltung und eingeschränkter Beweglichkeit führte.",
      afterText: "Hermine hat in nur einer Woche deutlich an Länge gewonnen. Ihre Wirbel geben wieder den Platz, den sie ursprünglich geben. Die Physio war begeistert - keine Blockaden oder Verspannungen mehr."
    },
  ];

  const handleMouseDown = () => {
    setIsDragging(true);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    
    const container = e.currentTarget;
    const rect = container.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percentage = (x / rect.width) * 100;
    
    setSliderPosition(Math.min(Math.max(percentage, 0), 100));
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    
    const container = e.currentTarget;
    const rect = container.getBoundingClientRect();
    const x = e.touches[0].clientX - rect.left;
    const percentage = (x / rect.width) * 100;
    
    setSliderPosition(Math.min(Math.max(percentage, 0), 100));
  };

  return (
    <div className="before-after-container">
      <div className="before-after-content">
        <div className="before-after-header">
          <h2 className="before-after-brand">Transformationen</h2>
          <h1 className="before-after-title">Vorher & Nachher</h1>
        </div>

        <div className="before-after-main">
          {/* Horse List */}
          <div className="horse-list">
            {horses.map((horse, index) => (
              <div
                key={index}
                className={`horse-card ${selectedHorse === index ? 'active' : ''}`}
                onClick={() => {
                  setSelectedHorse(index);
                  setSliderPosition(50);
                }}
              >
                <h3 className="horse-name">{horse.name}</h3>
                <div className="horse-details">
                  <span className="horse-location">{horse.location}</span>
                  <span className="horse-year">{horse.year}</span>
                </div>
              </div>
            ))}
          </div>

          {/* Image Comparison Slider */}
          <div className="comparison-container">
            <div className="comparison-slider-container">
              <div
                className="comparison-slider"
                onMouseDown={handleMouseDown}
                onMouseUp={handleMouseUp}
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseUp}
                onTouchStart={handleMouseDown}
                onTouchEnd={handleMouseUp}
                onTouchMove={handleTouchMove}
              >
                {/* After Image (Background) */}
                <div className="comparison-image after-image">
                  <img
                    src={horses[selectedHorse].afterImage}
                    alt={`${horses[selectedHorse].name} After`}
                    draggable="false"
                  />
                  <div className="image-label after-label">
                
                    Nachher
                  </div>
                </div>

                {/* Before Image (Overlay with clip) */}
                <div
                  className="comparison-image before-image"
                  style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}
                >
                  <img
                    src={horses[selectedHorse].beforeImage}
                    alt={`${horses[selectedHorse].name} Before`}
                    draggable="false"
                  />
                  <div className="image-label before-label">
                 
                    Vorher
                  </div>
                </div>

                {/* Slider Handle */}
                <div
                  className="slider-handle"
                  style={{ left: `${sliderPosition}%` }}
                >
                  <div className="slider-line"></div>
                  <div className="slider-button">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="comparison-description">
              <span className="description-label">
                <img src={sliderPosition <= 50 ? "/img/correct.svg" : "/img/close.svg"} alt={sliderPosition <= 50 ? "Nachher" : "Vorher"} />
                {sliderPosition <= 50 ? "Nachher:" : "Vorher:"}
              </span>
              <p>
              {sliderPosition <= 50 ? horses[selectedHorse].afterText : horses[selectedHorse].beforeText}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BeforeAfter;